// █▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀█
// █        JESSE STEWART         █
// █        UX/UI Designer        █
// █     www.JesseStewart.com     █
// █                              █
// █   (c) All Rights Reserved    █
// █▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄█

import React from "react";
/** @jsx jsx */ import { css, jsx } from "@emotion/core";
import { Helmet } from "react-helmet";
import styled from "@emotion/styled";
import animateScrollTo from "animated-scroll-to";
import {
  Typeset,
  Typepad,
  PageContainer,
  BgColor,
  BgColor2,
  DatesRange,
} from "../Partials/Typeset";
import { ContactInfo, Footer } from "../Partials/Ui";
import {
  sizes,
  expandValue,
  breakpoints,
  borderRadius,
} from "../../helpers/theme";
import { RadarChart, CircularGridLines, GradientDefs } from "react-vis";

import { experiences, references } from "../../helpers/data";

import JesseFace from "../../images/jesse_face-sm.jpg";
import JesseFaceScreen from "../../images/jesse_face_screen-sm.jpg";

import { Graph, LineGraph, Legend } from "../Partials/Graphs";

var tinycolor = require("tinycolor2");
var chroma = require("chroma-js");
var $ = require("jquery");

let GridStyles = (props) => css`
  .photo {
    position: relative;
    width: ${expandValue(sizes.space * 10)};
    height: ${expandValue(sizes.space * 10)};
    margin: 0 auto;
    background-color: ${props.theme.colors.bg1};
    background-image: url(${JesseFaceScreen});
    background-size: cover;
    background-blend-mode: screen;
    box-shadow: 0 ${expandValue(sizes.space * 0.125)}
        ${expandValue(sizes.space * 1.25)}
        ${tinycolor(props.theme.colors.primary).setAlpha(0.4).toString()},
      0 0 ${expandValue(sizes.space * 0.375)}
        ${tinycolor(props.theme.colors.secondary).setAlpha(0.6).toString()};
    ${borderRadius("50%")}
    &:after {
      content: " ";
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background-image: url(${JesseFace});
      background-size: cover;
      mix-blend-mode: overlay;
      ${borderRadius("50%")}
      opacity: 0.6;
    }
  }
  h1 {
    text-align: center;
    &:after {
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .contact-info {
    text-align: center;
    margin-bottom: ${expandValue(sizes.space * 2)};
  }
  .lead {
    text-align: center;
  }
  @media (min-width: ${expandValue(breakpoints[2])}) {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-column-gap: ${expandValue(sizes.space * 2)};
    h1 {
      text-align: left;
      &:after {
        left: 0;
        transform: translateX(0);
      }
    }
    .contact-info {
      text-align: left;
      margin-bottom: 0;
    }
    .lead {
      text-align: left;
    }
  }
`;
let GridStyled = styled("div")`
  ${GridStyles}
`;

export class PageResume extends React.Component {
  componentDidMount() {
    const options = {
      // duration of the scroll per 1000px, default 500
      speed: 0,
      // minimum duration of the scroll
      minDuration: 0,
      // maximum duration of the scroll
      maxDuration: 0,
    };
    animateScrollTo(0, options);
    $("#Top").addClass("Banished");
  }

  render() {
    let colorScale = chroma
      .scale([
        this.props.theme.colors.primary,
        this.props.theme.colors.secondary,
      ])
      .mode("lab");

    const DATA = [
      {
        Branding: 82,
        UX: 91,
        UI: 96,
        HTML: 99,
        CSS: 100,
        Accessibility: 100,
        Mobile: 93,
        Animation: 71,
        Rust: 36,
        JS: 100,
        React: 100,
        Angular: 100,
      },
    ];

    const DOMAIN = [
      { name: "Branding", domain: [0, 100] },
      { name: "UX", domain: [0, 100] },
      { name: "UI", domain: [0, 100] },
      { name: "HTML", domain: [0, 100] },
      { name: "CSS", domain: [0, 100] },
      { name: "Accessibility", domain: [0, 100] },
      { name: "Mobile", domain: [0, 100] },
      { name: "Animation", domain: [0, 100] },
      { name: "Rust", domain: [0, 100] },
      { name: "JS", domain: [0, 100] },
      { name: "React", domain: [0, 100] },
      { name: "Angular", domain: [0, 100] },
    ];

    return (
      <PageContainer>
        <Helmet>
          <title>Resume - Jesse Stewart | User Interface Designer</title>
          <meta
            itemprop="description"
            content="User flows, Wireframing, Interface Design, Prototyping, Logo Design, Identity, Adobe XD, Adobe Illustrator, Adobe Photoshop, Adobe After Effects, Adobe Premiere, Figma. Front-End Web Development, React, Angular, HTML5, CSS3, SCSS, GIT, Javascript, jQuery, Bootstrap, Magento, Wordpress, Roots.io. East Lansing, Michigan."
          />
        </Helmet>
        <div css={{ minHeight: "50vh" }}>
          <Typepad pageTop>
            <Typeset>
              <GridStyled>
                <h1>Resume</h1>

                <div>
                  <p className="lead">
                    Staff <em>Software Engineer &amp; UI/UX designer</em>{" "}
                    <span className="no-break">with over 20-years</span> of
                    experience creating{" "}
                    <span className="no-break">web applications.</span>
                  </p>
                  <ContactInfo />
                </div>

                <div style={{ gridColumn: "3/4", placeSelf: "center" }}>
                  <div className="photo" />
                </div>
              </GridStyled>
            </Typeset>
          </Typepad>
        </div>

        <BgColor>
          <Typepad>
            <Typeset>
              <GridStyled>
                <div>
                  <h3>Development</h3>
                  <p>
                    Software Engineering, Web Development, React, Angular, NextJS, Nx,
                    HTML5, CSS3, SCSS, TailwindCSS, GIT, Accessibility,
                    Javascript, Magento.
                  </p>
                </div>
                <div style={{ gridColumn: "1/2" }}>
                  <h3>Design</h3>
                  <p>
                    User flows, Wireframing, Interface Design, Prototyping, Logo
                    Design, Identity, Figma, Adobe Illustrator, Adobe Photoshop,
                    Adobe After Effects, Adobe Premiere
                  </p>
                </div>
                <div>
                  <Graph>
                    <RadarChart
                      data={DATA}
                      domains={DOMAIN}
                      margin={{
                        left: sizes.space * 2,
                        top: sizes.space * 2,
                        bottom: sizes.space * 2,
                        right: sizes.space * 2,
                      }}
                      style={{
                        polygons: {
                          stroke: this.props.theme.colors.primary,
                          fill: "url(#colorScale2)",
                          strokeWidth: 1,
                          strokeOpacity: 1,
                          fillOpacity: 0.4,
                        },
                        labels: {
                          textAnchor: "middle",
                        },
                      }}
                      tickFormat={(t) => ""}
                      width={304}
                      height={304}
                      className="radar-chart"
                    >
                      <GradientDefs>
                        <linearGradient
                          id="colorScale2"
                          x1="0"
                          x2="0"
                          y1="0"
                          y2="1"
                        >
                          <stop
                            offset="0%"
                            stopColor={this.props.theme.colors.primary}
                            stopOpacity={0.6}
                          />
                          <stop
                            offset="100%"
                            stopColor={this.props.theme.colors.secondary}
                            stopOpacity={0.4}
                          />
                        </linearGradient>
                      </GradientDefs>
                      <CircularGridLines
                        tickValues={[...new Array(10)].map(
                          (v, i) => i / 10 - 1
                        )}
                      />
                    </RadarChart>
                  </Graph>
                </div>
              </GridStyled>
              <div>
                <h5>Key Technologies</h5>
                <div>
                  <Legend
                    id="project-timeline"
                    colorPrimary={this.props.theme.colors.primary}
                    colorSecondary={this.props.theme.colors.secondary}
                    data={[
                      { name: "PHP" },
                      { name: "Magento" },
                      { name: "Shopify" },
                      { name: "Wordpress" },
                      { name: "React" },
                      { name: "NextJs" },
                      { name: "Angular" },
                      { name: "Rust" },
                    ]}
                  />
                </div>
                <div>
                  <LineGraph
                    id="project-timeline"
                    colorPrimary={this.props.theme.colors.primary}
                    colorSecondary={this.props.theme.colors.secondary}
                    data={[
                      {
                        name: "PHP",
                        data: [
                          { x: new Date("01/01/2003"), y: 12 },
                          { x: new Date("01/01/2004"), y: 36 },
                          { x: new Date("01/01/2005"), y: 43 },
                          { x: new Date("01/01/2006"), y: 54 },
                          { x: new Date("01/01/2007"), y: 65 },
                          { x: new Date("01/01/2008"), y: 70 },
                          { x: new Date("01/01/2009"), y: 65 },
                          { x: new Date("01/01/2010"), y: 40 },
                          { x: new Date("01/01/2011"), y: 41 },
                          { x: new Date("01/01/2012"), y: 43 },
                          { x: new Date("01/01/2013"), y: 45 },
                          { x: new Date("01/01/2014"), y: 32 },
                          { x: new Date("01/01/2015"), y: 31 },
                          { x: new Date("01/01/2016"), y: 0 },
                        ],
                      },
                      {
                        name: "Magento",
                        data: [
                          { x: new Date("01/01/2007"), y: 0 },
                          { x: new Date("01/01/2008"), y: 5 },
                          { x: new Date("01/01/2009"), y: 35 },
                          { x: new Date("01/01/2010"), y: 78 },
                          { x: new Date("01/01/2011"), y: 89 },
                          { x: new Date("01/01/2012"), y: 91 },
                          { x: new Date("01/01/2013"), y: 92 },
                          { x: new Date("01/01/2014"), y: 88 },
                          { x: new Date("01/01/2015"), y: 75 },
                          { x: new Date("01/01/2017"), y: 5 },
                          { x: new Date("01/01/2018"), y: 5 },
                          { x: new Date("01/01/2019"), y: 5 },
                          { x: new Date("01/01/2020"), y: 15 },
                          { x: new Date("01/01/2021"), y: 35 },
                          { x: new Date("01/01/2022"), y: 46 },
                          { x: new Date("01/01/2023"), y: 40 },
                          { x: new Date("01/01/2024"), y: 42 },
                        ],
                      },
                      {
                        name: "Shopify",
                        data: [
                          { x: new Date("01/01/2018"), y: 0 },
                          { x: new Date("01/01/2019"), y: 10 },
                          { x: new Date("01/01/2020"), y: 19 },
                          { x: new Date("01/01/2021"), y: 46 },
                          { x: new Date("01/01/2022"), y: 56 },
                          { x: new Date("01/01/2023"), y: 74 },
                          { x: new Date("01/01/2024"), y: 49 },
                        ],
                      },
                      {
                        name: "Wordpress",
                        data: [
                          { x: new Date("01/01/2003"), y: 0 },
                          { x: new Date("01/01/2004"), y: 15 },
                          { x: new Date("01/01/2005"), y: 18 },
                          { x: new Date("01/01/2006"), y: 32 },
                          { x: new Date("01/01/2007"), y: 26 },
                          { x: new Date("01/01/2008"), y: 55 },
                          { x: new Date("01/01/2009"), y: 71 },
                          { x: new Date("01/01/2010"), y: 62 },
                          { x: new Date("01/01/2011"), y: 59 },
                          { x: new Date("01/01/2012"), y: 89 },
                          { x: new Date("01/01/2013"), y: 92 },
                          { x: new Date("01/01/2014"), y: 68 },
                          { x: new Date("01/01/2015"), y: 75 },
                          { x: new Date("01/01/2016"), y: 38 },
                          { x: new Date("01/01/2017"), y: 0 },
                        ],
                      },
                      {
                        name: "React",
                        data: [
                          { x: new Date("01/01/2014"), y: 0 },
                          { x: new Date("01/01/2015"), y: 5 },
                          { x: new Date("01/01/2016"), y: 20 },
                          { x: new Date("01/01/2017"), y: 40 },
                          { x: new Date("01/01/2018"), y: 48 },
                          { x: new Date("01/01/2019"), y: 71 },
                          { x: new Date("01/01/2020"), y: 60 },
                          { x: new Date("01/01/2021"), y: 50 },
                          { x: new Date("01/01/2022"), y: 40 },
                          { x: new Date("01/01/2023"), y: 30 },
                          { x: new Date("01/01/2024"), y: 33 },
                        ],
                      },
                      {
                        name: "NextJs",
                        data: [
                          { x: new Date("01/01/2019"), y: 0 },
                          { x: new Date("01/01/2020"), y: 20 },
                          { x: new Date("01/01/2021"), y: 56 },
                          { x: new Date("01/01/2022"), y: 69 },
                          { x: new Date("01/01/2023"), y: 74 },
                          { x: new Date("01/01/2024"), y: 80 },
                        ],
                      },
                      {
                        name: "Angular",
                        data: [
                          { x: new Date("01/01/2018"), y: 0 },
                          { x: new Date("01/01/2019"), y: 31 },
                          { x: new Date("01/01/2020"), y: 60 },
                          { x: new Date("01/01/2021"), y: 71 },
                          { x: new Date("01/01/2022"), y: 80 },
                          { x: new Date("01/01/2023"), y: 90 },
                          { x: new Date("01/01/2024"), y: 100 },
                        ],
                      },
                      {
                        name: "Rust",
                        data: [
                          { x: new Date("01/01/2022"), y: 0 },
                          { x: new Date("01/01/2023"), y: 15 },
                          { x: new Date("01/01/2024"), y: 28 },
                        ],
                      },
                    ]}
                  />
                </div>

                <h5>Front-End</h5>

                <div>
                  <Legend
                    id="project-timeline"
                    colorPrimary={this.props.theme.colors.primary}
                    colorSecondary={this.props.theme.colors.secondary}
                    data={[
                      { name: "HTML" },
                      { name: "HTML5" },
                      { name: "CSS" },
                      { name: "SCSS" },
                      { name: "CSS in JS" },
                      { name: "TailwindCSS" },
                    ]}
                  />
                </div>
                <div>
                  <LineGraph
                    id="project-timeline"
                    colorPrimary={this.props.theme.colors.primary}
                    colorSecondary={this.props.theme.colors.secondary}
                    data={[
                      {
                        name: "HTML",
                        data: [
                          { x: new Date("01/01/2003"), y: 47 },
                          { x: new Date("01/01/2004"), y: 62 },
                          { x: new Date("01/01/2005"), y: 86 },
                          { x: new Date("01/01/2006"), y: 91 },
                          { x: new Date("01/01/2007"), y: 99 },
                          { x: new Date("01/01/2008"), y: 98 },
                          { x: new Date("01/01/2009"), y: 99 },
                          { x: new Date("01/01/2010"), y: 95 },
                          { x: new Date("01/01/2011"), y: 90 },
                          { x: new Date("01/01/2012"), y: 98 },
                          { x: new Date("01/01/2013"), y: 97 },
                          { x: new Date("01/01/2014"), y: 57 },
                          { x: new Date("01/01/2015"), y: 15 },
                          { x: new Date("01/01/2016"), y: 0 },
                        ],
                      },
                      {
                        name: "HTML5",
                        data: [
                          { x: new Date("01/01/2007"), y: 0 },
                          { x: new Date("01/01/2008"), y: 21 },
                          { x: new Date("01/01/2009"), y: 36 },
                          { x: new Date("01/01/2010"), y: 66 },
                          { x: new Date("01/01/2011"), y: 78 },
                          { x: new Date("01/01/2012"), y: 98 },
                          { x: new Date("01/01/2013"), y: 97 },
                          { x: new Date("01/01/2014"), y: 94 },
                          { x: new Date("01/01/2015"), y: 93 },
                          { x: new Date("01/01/2016"), y: 94 },
                          { x: new Date("01/01/2017"), y: 95 },
                          { x: new Date("01/01/2018"), y: 99 },
                          { x: new Date("01/01/2019"), y: 100 },
                          { x: new Date("01/01/2020"), y: 100 },
                          { x: new Date("01/01/2021"), y: 100 },
                          { x: new Date("01/01/2022"), y: 100 },
                          { x: new Date("01/01/2023"), y: 100 },
                          { x: new Date("01/01/2024"), y: 100 },
                        ],
                      },

                      {
                        name: "CSS",
                        data: [
                          { x: new Date("01/01/2003"), y: 31 },
                          { x: new Date("01/01/2004"), y: 45 },
                          { x: new Date("01/01/2005"), y: 67 },
                          { x: new Date("01/01/2006"), y: 82 },
                          { x: new Date("01/01/2007"), y: 93 },
                          { x: new Date("01/01/2008"), y: 94 },
                          { x: new Date("01/01/2009"), y: 95 },
                          { x: new Date("01/01/2010"), y: 95 },
                          { x: new Date("01/01/2011"), y: 90 },
                          { x: new Date("01/01/2012"), y: 69 },
                          { x: new Date("01/01/2013"), y: 36 },
                          { x: new Date("01/01/2014"), y: 24 },
                          { x: new Date("01/01/2015"), y: 34 },
                          { x: new Date("01/01/2016"), y: 38 },
                          { x: new Date("01/01/2017"), y: 31 },
                          { x: new Date("01/01/2018"), y: 33 },
                          { x: new Date("01/01/2019"), y: 30 },
                          { x: new Date("01/01/2020"), y: 25 },
                          { x: new Date("01/01/2021"), y: 21 },
                          { x: new Date("01/01/2022"), y: 20 },
                          { x: new Date("01/01/2023"), y: 19 },
                          { x: new Date("01/01/2024"), y: 11 },
                        ],
                      },
                      {
                        name: "SCSS",
                        data: [
                          { x: new Date("01/01/2010"), y: 0 },
                          { x: new Date("01/01/2011"), y: 5 },
                          { x: new Date("01/01/2012"), y: 34 },
                          { x: new Date("01/01/2013"), y: 58 },
                          { x: new Date("01/01/2014"), y: 78 },
                          { x: new Date("01/01/2015"), y: 86 },
                          { x: new Date("01/01/2016"), y: 89 },
                          { x: new Date("01/01/2017"), y: 93 },
                          { x: new Date("01/01/2018"), y: 100 },
                          { x: new Date("01/01/2019"), y: 100 },
                          { x: new Date("01/01/2020"), y: 100 },
                          { x: new Date("01/01/2021"), y: 100 },
                          { x: new Date("01/01/2022"), y: 100 },
                          { x: new Date("01/01/2023"), y: 100 },
                          { x: new Date("01/01/2024"), y: 80 },
                        ],
                      },
                      {
                        name: "CSS in JS",
                        data: [
                          { x: new Date("01/01/2016"), y: 0 },
                          { x: new Date("01/01/2017"), y: 31 },
                          { x: new Date("01/01/2018"), y: 45 },
                          { x: new Date("01/01/2019"), y: 88 },
                          { x: new Date("01/01/2020"), y: 72 },
                          { x: new Date("01/01/2021"), y: 66 },
                          { x: new Date("01/01/2022"), y: 21 },
                          { x: new Date("01/01/2023"), y: 15 },
                          { x: new Date("01/01/2024"), y: 40 },
                        ],
                      },
                      {
                        name: "TailwindCSS",
                        data: [
                          { x: new Date("01/01/2020"), y: 0 },
                          { x: new Date("01/01/2021"), y: 25 },
                          { x: new Date("01/01/2022"), y: 75 },
                          { x: new Date("01/01/2023"), y: 100 },
                          { x: new Date("01/01/2024"), y: 100 },
                        ],
                      },
                    ]}
                  />
                </div>

                <h5>Design Tools</h5>
                <div>
                  <Legend
                    id="project-timeline"
                    colorPrimary={this.props.theme.colors.primary}
                    colorSecondary={this.props.theme.colors.secondary}
                    data={[
                      { name: "Photoshop" },
                      { name: "Illustrator" },
                      { name: "InVision" },
                      { name: "Adobe XD" },
                      { name: "Figma" },
                    ]}
                  />
                </div>
                <div>
                  <LineGraph
                    id="project-timeline"
                    colorPrimary={this.props.theme.colors.primary}
                    colorSecondary={this.props.theme.colors.secondary}
                    data={[
                      {
                        name: "Photoshop",
                        data: [
                          { x: new Date("01/01/2003"), y: 59 },
                          { x: new Date("01/01/2004"), y: 63 },
                          { x: new Date("01/01/2005"), y: 79 },
                          { x: new Date("01/01/2006"), y: 96 },
                          { x: new Date("01/01/2007"), y: 100 },
                          { x: new Date("01/01/2008"), y: 100 },
                          { x: new Date("01/01/2009"), y: 96 },
                          { x: new Date("01/01/2010"), y: 88 },
                          { x: new Date("01/01/2011"), y: 80 },
                          { x: new Date("01/01/2012"), y: 71 },
                          { x: new Date("01/01/2013"), y: 66 },
                          { x: new Date("01/01/2014"), y: 53 },
                          { x: new Date("01/01/2015"), y: 42 },
                          { x: new Date("01/01/2016"), y: 32 },
                          { x: new Date("01/01/2017"), y: 33 },
                          { x: new Date("01/01/2018"), y: 31 },
                          { x: new Date("01/01/2019"), y: 40 },
                          { x: new Date("01/01/2020"), y: 41 },
                          { x: new Date("01/01/2021"), y: 38 },
                          { x: new Date("01/01/2022"), y: 41 },
                          { x: new Date("01/01/2023"), y: 36 },
                          { x: new Date("01/01/2024"), y: 30 },
                        ],
                      },
                      {
                        name: "Illustrator",
                        data: [
                          { x: new Date("01/01/2003"), y: 45 },
                          { x: new Date("01/01/2004"), y: 41 },
                          { x: new Date("01/01/2005"), y: 47 },
                          { x: new Date("01/01/2006"), y: 31 },
                          { x: new Date("01/01/2007"), y: 31 },
                          { x: new Date("01/01/2008"), y: 36 },
                          { x: new Date("01/01/2009"), y: 39 },
                          { x: new Date("01/01/2010"), y: 20 },
                          { x: new Date("01/01/2011"), y: 46 },
                          { x: new Date("01/01/2012"), y: 87 },
                          { x: new Date("01/01/2013"), y: 92 },
                          { x: new Date("01/01/2014"), y: 100 },
                          { x: new Date("01/01/2015"), y: 98 },
                          { x: new Date("01/01/2016"), y: 99 },
                          { x: new Date("01/01/2017"), y: 98 },
                          { x: new Date("01/01/2018"), y: 80 },
                          { x: new Date("01/01/2019"), y: 77 },
                          { x: new Date("01/01/2020"), y: 51 },
                          { x: new Date("01/01/2021"), y: 58 },
                          { x: new Date("01/01/2022"), y: 61 },
                          { x: new Date("01/01/2023"), y: 56 },
                          { x: new Date("01/01/2024"), y: 40 },
                        ],
                      },

                      {
                        name: "InVision",
                        data: [
                          { x: new Date("01/01/2010"), y: 0 },
                          { x: new Date("01/01/2011"), y: 9 },
                          { x: new Date("01/01/2012"), y: 17 },
                          { x: new Date("01/01/2013"), y: 59 },
                          { x: new Date("01/01/2014"), y: 71 },
                          { x: new Date("01/01/2015"), y: 98 },
                          { x: new Date("01/01/2016"), y: 78 },
                          { x: new Date("01/01/2017"), y: 84 },
                          { x: new Date("01/01/2018"), y: 55 },
                          { x: new Date("01/01/2019"), y: 60 },
                          { x: new Date("01/01/2020"), y: 60 },
                          { x: new Date("01/01/2021"), y: 0 },
                        ],
                      },
                      {
                        name: "Adobe XD",
                        data: [
                          { x: new Date("01/01/2016"), y: 0 },
                          { x: new Date("01/01/2017"), y: 48 },
                          { x: new Date("01/01/2018"), y: 78 },
                          { x: new Date("01/01/2019"), y: 69 },
                          { x: new Date("01/01/2020"), y: 60 },
                          { x: new Date("01/01/2021"), y: 60 },
                          { x: new Date("01/01/2022"), y: 0 },
                        ],
                      },
                      {
                        name: "Figma",
                        data: [
                          { x: new Date("01/01/2019"), y: 0 },
                          { x: new Date("01/01/2020"), y: 25 },
                          { x: new Date("01/01/2021"), y: 65 },
                          { x: new Date("01/01/2022"), y: 75 },
                          { x: new Date("01/01/2023"), y: 90 },
                          { x: new Date("01/01/2024"), y: 100 },
                        ],
                      },
                    ]}
                  />
                </div>
              </div>
            </Typeset>
          </Typepad>
        </BgColor>

        <Typepad>
          <Typeset>
            <h2>Experience</h2>

            {experiences.map((experience, index) => (
              <div
                css={{ marginBottom: expandValue(sizes.space * 2) }}
                key={"experience_" + index}
              >
                <GridStyled>
                  <div>
                    <h4 style={{ marginBottom: 0 }}>{experience.company}</h4>
                    <h5>{experience.title}</h5>
                  </div>
                  <div style={{ gridColumn: "1/2" }} className="job-info">
                    <DatesRange>{experience.dates}</DatesRange>
                    <p>
                      {experience.location}
                      <br />
                      {experience.website && (
                        <a
                          href={"http://" + experience.website}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {experience.website}
                        </a>
                      )}
                    </p>
                  </div>
                  <div
                    style={{ gridColumn: "2/4" }}
                    className="job-description"
                  >
                    <p>{experience.desc}</p>
                    <ul className="list-inline tags">
                      <li className="label">Key Technologies:</li>
                      {experiences[index].techs.map((tech, tindex) => (
                        <li key={"tech_" + index + "_" + tindex}>{tech}</li>
                      ))}
                    </ul>
                  </div>
                </GridStyled>
              </div>
            ))}
          </Typeset>
        </Typepad>

        <BgColor2>
          <Typepad>
            <Typeset>
              <h2>References</h2>
              {references.map((reference, index) => (
                <div
                  css={{ marginBottom: expandValue(sizes.space * 2) }}
                  key={"reference_" + index}
                >
                  <GridStyled>
                    <h4>{reference.name}</h4>
                    <div style={{ gridColumn: "1/2" }} className="job-info">
                      <p>
                        {references[index].titles.map((title, tindex) => (
                          <span key={"title_" + index + "_" + tindex}>
                            {title}
                            <br />
                          </span>
                        ))}
                        <a
                          href={"mailto:" + reference.email}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {reference.email}
                        </a>
                      </p>
                    </div>
                    <div
                      style={{ gridColumn: "2/4" }}
                      className="job-description"
                    >
                      <p>{reference.desc}</p>
                    </div>
                  </GridStyled>
                </div>
              ))}
            </Typeset>
          </Typepad>
        </BgColor2>

        <Footer />
      </PageContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Pages/Resume.js